<div class="mx-4">
    <div class="d-flex align-items-center px-2 py-3 justify-content-between">
        <h5 class="modal-title">{{ title }}</h5>
        <button *ngIf="viewCrossBtn" type="button" class="btn btn-sm btn-outline-secondary"
            (click)="activeModal.dismiss('Cross click')">
            X
        </button>
    </div>
    <div class="d-flex border-top border-bottom flex-column p-2 popUpCont">
        <div class="popUpCont mb-2">
            <div class="d-flex mb-3 align-items-center">
                <p style="margin: 0; white-space: pre-line;" [innerHtml]="message"></p>
            </div>
            <div class="d-flex mb-3 flex-column" *ngIf="viewSalesMessage">
                <p>{{ salesMessage }}<a *ngIf="viewLink" target="_blank" [href]="link">{{ linkMessage }}</a></p>
            </div>
            <div *ngIf="viewRadioBtn">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                        [(ngModel)]="selectedOption" value="yes" />
                    <label class="form-check-label" for="inlineRadio2">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                        [(ngModel)]="selectedOption" value="no" checked="true" />
                    <label class="form-check-label" for="inlineRadio1">No</label>
                </div>
            </div>
            <form [formGroup]="inputForm" class="form-row p-0" *ngIf="viewInput" >
                <input type="text" name="CouponId" class="form-control form-control-sm d-flex"
                    placeholder="{{placeholder}}" formControlName="inputValue"
                    [ngClass]="{ 'is-invalid': validationError || errorMessage }" autocomplete="off"/>
                <div *ngIf="errorMessage" class="text-danger mt-1 mx-2">
                    {{ errorMessage }}
                </div>
            </form>
        </div>
    </div>
    <div class="d-flex justify-content-end px-2 pb-4 pt-3">
        <button [ngClass]="btnTitleColor" type="button" class="btn btn-sm me-2"
            [disabled]="selectedOption === 'no' && !inputForm.valid && (viewRadioBtn || viewInput)"
            (click)="returnValue()">
            {{ btnTitle }}
        </button>
        <button *ngIf="viewCancelBtn" type="button" class="btn btn-sm btn-outline-primary"
            (click)="activeModal.close('Close click')">
            Cancel
        </button>
    </div>
</div>